import React from "react";
import { useSelectContext } from "./Select";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  item: {
    cursor: "pointer",
    borderRadius: "4px",
    whiteSpace: "nowrap",
    "&:hover": {
      backgroundColor: "#F8F8F8",
    },
  },
  selected: {
    backgroundColor: "#EDEDED",
  },
  danger: {
    color: "#D84949",
    "&:hover": {
      backgroundColor: "#F8F8F8",
    },
  },
  dangerSelected: {
    backgroundColor: "#EDEDED",
    color: "#D84949",
  },
}));

const SelectItem = ({ value, children, searchText, variant = "default" }) => {
  const { selectValue, value: selectedValue, searchable, searchTerm, sizeMeasurements } = useSelectContext();
  const classes = useStyles();
  const isSelected = value === selectedValue;

  // If searchable is enabled and there's a search term, filter items
  const itemText = searchText || (typeof children === "string" ? children : "");
  const shouldShow = !searchable || !searchTerm || itemText.toLowerCase().includes(searchTerm.toLowerCase()) || (value && value.toString().toLowerCase().includes(searchTerm.toLowerCase()));

  if (!shouldShow) {
    return null;
  }

  // Determine the CSS class based on variant and selection state
  const getItemClass = () => {
    if (variant === "danger") {
      return `${classes.item} ${classes.danger} ${isSelected ? classes.dangerSelected : ""}`;
    }
    return `${classes.item} ${isSelected ? classes.selected : ""}`;
  };

  return (
    <div className={getItemClass()} onClick={() => selectValue(value)} style={{ padding: sizeMeasurements.padding }}>
      {children}
    </div>
  );
};

export default SelectItem;
